import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { Box, makeStyles, Typography, Grid } from "@material-ui/core";

import { getData } from "../../services";
import { GlanceTab } from "./tabsV2/glance/GlanceTab";
import { PropertiesTab } from "./tabsV2/properties/PropertiesTab";
import { TenantsTab } from "./tabsV2/tenants/TenantsTab";
import { COLORS } from "../../theme/colors";
import Menu from "../../components/menu/Menu";
import { HorizontalTabs } from "../../components/horizontalTabs";

const useStyles = makeStyles((theme) => ({
  rootContainer: {
    position: "relative",
  },
  address: {
    lineHeight: 2.5,
    marginLeft: theme.spacing(1),
    color: COLORS.darks[1],
  },
  root: {
    padding: `${theme.spacing(2.5)}px ${theme.spacing(4)}px`,
    marginLeft: theme.spacing(4.2),
    height: "100%",
    boxSizing: "border-box",
    flexGrow: 1,
  },
}));

export const BuildingPage = () => {
  const classes = useStyles();
  const [tab, setTab] = useState(0);
  const { id } = useParams();
  const navigate = useNavigate();
  const [buildings, setBuildings] = useState([]);
  const [complexes, setComplexes] = useState([]);
  const [building, setBuilding] = useState();

  const TabComponent = [GlanceTab, PropertiesTab, TenantsTab][tab];

  useEffect(() => {
    getData("/praas/v2/complexes/", setComplexes);
    getData("/praas/v2/buildings/without-complex/", setBuildings);
  }, []);

  useEffect(() => getData(`/praas/v1/buildings/${id}/`, setBuilding), [id]);

  return (
    <Grid className={classes.rootContainer} container>
      <Menu navigate={navigate} selectedBuilding={id} complexes={complexes} buildings={buildings} />

      {building && (
        <Box className={classes.root}>
          <Grid container>
            <Typography variant="h2" style={{ fontWeight: 400 }}>
              {building.name}
            </Typography>
            <Typography className={classes.address}>{building.address}</Typography>
          </Grid>

          <HorizontalTabs
            tab={tab}
            setTab={setTab}
            tabNames={["At a Glance", "Properties", "Tenants"]}
          />
          <TabComponent building={building} />
        </Box>
      )}
    </Grid>
  );
};
